/*
 * zeroLabs Labor: weitere Produktseiten (sections/zl-produkt-objekt.liquid, zl-produkt-neukunden.liquid, zl-produkt-standard.liquid).
 *
 * Bühne: das Wort füllt die Breite, der Kauf steht darunter wie in Produktseite B. Kopf messen, Leiste, die mitkommt,
 * und das Formular des Themes (theme.AjaxProduct) arbeiten wie in assets/zl-produkt-buehne.js, nur ohne Flasche in WebGL.
 * Gutscheine: der Betrags-Wähler holt dieselbe Sektion für den anderen Betrag (Section Rendering API), ohne Neuladen.
 * Unter dem Kauf: Was du bekommst rastet Fach für Fach ein, wenn es ins Bild kommt (Feder aus der Seite).
 * Regler (nur Labor, im Browser gespeichert unter 'zl-weitere-labor-1'): Richtung und Überschrift, als data-Attribute an html.
 */
(() => {
  'use strict';
  const root0 = document.querySelector('[data-zl-o]');
  if (!root0) return;
  const html = document.documentElement;
  const vorlage = root0.dataset.vorlage;
  const sectionId = root0.dataset.sectionId;
  const reduziert = () => !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  const breitBild = () => window.innerWidth >= 1025; // token-ok: Desktop ab 1025 wie in B (docs/abstaende.md)
  const root = () => document.querySelector('[data-zl-o]');

  /* ---------- Regler (nur Labor) ---------- */
  /* Regler-Werte, gespeicherte Wahl und die data-Attribute an html kommen aus snippets/zl-produkt-wahl.liquid, das schon vor dem
     Zeichnen läuft. Ohne es (alte Seite im Zwischenspeicher) bleibt es bei der Grundfassung. */
  const wahl = window.zlProduktWahl || { prefs: {}, echt: true, merke() {}, zeige() {} };
  const { prefs, echt, merke } = wahl;
  /* Labor auf dem Mixpaket: der Tab heißt wie das Produkt, das er zeigt (Moritz, 08.10.2026). Beim echten Produkt kommt der Titel
     aus Shopify, der Name dort muss Adventskalender heißen (docs/golive.md). */
  if (vorlage === 'advent' && !/advent/i.test(document.title)) document.title = 'Adventskalender | zeroLabs';
  /* Adventskalender: beim Neuladen immer oben ankommen (Moritz, 07.10.2026), der Browser stellt die Scrollstelle nicht wieder her */
  if (vorlage === 'advent' && 'scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
    if (!location.hash) window.scrollTo(0, 0);
  }
  /* Runde 13 (Moritz, 08.10.2026: beide Fassungen als Regler): zwei Sätze der Geschichte konkreter, ohne neue Behauptung.
     Die neuen Fassungen stützen sich auf die Antwort zur Brauerei in den Fragen (seit dem 16. Jahrhundert) und auf die Zutatenlisten. */
  const TEXTE = [
    { wo: '.zl-g--weg .zl-g__kapitel--ort .zl-g__text', neu: 'So viel Zeit bekommt unser Bier bei unserer Partnerbrauerei in Bayern. Dort wird seit dem 16. Jahrhundert gebraut.' },
    { wo: '.zl-g--weg .zl-g__kapitel--rein .zl-g__titel', neu: 'Fünf Sorten. Zutaten, die man kennt.' }
  ];
  /* Erster Satz vor den Sorten (Moritz, 08.10.2026): drei Fassungen zum Vergleich am Gerät, die Einstellung der Sektion ist Fassung 1 */
  const VORAB = { '1': 'Was in 25 Türchen passt.', '2': 'Einmal spicken. Dann nie wieder.', '3': 'Spoiler.' };
  const vorabSatz = (welche) => {
    const el = document.querySelector('[data-zl-ad-vorab]');
    if (!el) return;
    if (!el.dataset.zlOriginal) el.dataset.zlOriginal = el.innerHTML;
    el.innerHTML = welche === '1' || !VORAB[welche] ? el.dataset.zlOriginal : VORAB[welche];
  };
  const texteTauschen = (welche) => {
    TEXTE.forEach((t) => {
      const el = document.querySelector(t.wo); if (!el) return;
      if (!('alt' in el.dataset)) el.dataset.alt = el.textContent;
      el.textContent = welche === 'neu' ? t.neu : el.dataset.alt;
    });
  };
  const zeigePrefs = () => {
    wahl.zeige();
    if (vorlage === 'advent') { vorabSatz(prefs.avorab); texteTauschen(prefs.atexte); }
  };
  zeigePrefs();

  const regler = () => {
    if (echt) return;
    const knopf = document.createElement('button');
    knopf.type = 'button'; knopf.className = 'zl-b-regler-knopf';
    knopf.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" style="stroke-width: var(--zl-symbol-strich)" stroke-linecap="round" aria-hidden="true"><path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/></svg>';
    knopf.setAttribute('aria-label', 'Regler'); knopf.setAttribute('aria-expanded', 'false'); knopf.setAttribute('aria-controls', 'zl-w-regler');
    const feld = document.createElement('div'); feld.className = 'zl-b-regler'; feld.id = 'zl-w-regler'; feld.hidden = true;
    const gtitel = (i) => { const el = document.querySelector('.zl-n__gtitel-' + i); return el ? el.textContent.trim() : 'Überschrift ' + i; };
    const atitel = (i) => { const el = document.querySelector('.zl-n__atitel-' + i); return el ? el.textContent.trim() : 'Überschrift ' + i; };
    const titel = (i) => { const el = document.querySelector('.zl-n__titel-' + i); return el ? el.textContent.trim() : 'Überschrift ' + i; };
    const gruppen = vorlage === 'neukunden' ? [
      { key: 'fold', titel: 'Fold (Runde 5)', optionen: [['bon', 'Der Bon: Inhalt mit Wert, einzeln gegen Probierpaket'], ['bisher', 'Bisher: Runden 1 bis 4 nach den Reglern darunter']] },
      { key: 'gratis', titel: 'Gratis im Bon (Runde 6)', optionen: [['strich', 'B Der Strich: der Marker streicht den Preis durch'], ['marker', 'A Marker: schräg in UltraViolet, wie in B'], ['null', 'C 0,0: der Preis der Geschenke wie auf der Flasche'], ['wort', 'D Nur das Wort: Gratis, ohne Fläche']] },
      { key: 'buehne', titel: 'Bühne (Runde 4, stellt Fold auf Bisher)', optionen: [['standard', 'Wie bisher, Geschenke nach Regler darunter'], ['plus', 'A Das Plus: Flaschen + Geschenke'], ['wortplus', 'B Plus im Wort: + und die Geschenke in Wortgröße'], ['rechnung', 'C Die Rechnung: 24 + 2 hinter den Flaschen'], ['geschenk', 'D Geschenk vorn: Tasche voller Flaschen']] },
      { key: 'geschenk', titel: 'Geschenke oben (Runde 2 und 3, stellt Fold auf Bisher)', optionen: [['kauf', '1 Im Kauf, über dem Preis'], ['buehne', '2 Auf der Bühne, neben den Flaschen'], ['etikett', '3 Ein Etikett, das man aufmacht'], ['zeile', '4 Nur die Zeile, dazu die Leiste']] },
      { key: 'gtitel', titel: 'Geschenke unter dem Kauf: Überschrift', optionen: [['1', gtitel(1)], ['2', gtitel(2)], ['3', gtitel(3)]] },
      { key: 'wert', titel: 'Wert der Geschenke (Freigabe offen)', optionen: [['aus', 'Nur "Gratis."'], ['an', 'Mit Wert aus Shopify']] },
      { key: 'atitel', titel: 'Überschrift über den Auszeichnungen (Runde 7)', optionen: [['1', atitel(1)], ['2', atitel(2)], ['3', atitel(3)]] },
      { key: 'n', titel: 'Unter dem Kauf', optionen: [['fragen', '1 Die Fragen'], ['auspacken', '2 Was du bekommst'], ['gruender', '3 Max und Moritz antworten'], ['satz', '4 Ein Satz']] },
      { key: 'titel', titel: 'Überschrift über den Fragen', optionen: [['1', titel(1)], ['2', titel(2)], ['3', titel(3)], ['4', titel(4)]] }
    ] : vorlage === 'advent' ? [
      { key: 'aseite', titel: 'Seite unter dem Fold (Runde 10, lädt neu)', optionen: [['A', 'A Ein Schnitt: Türchen 7 auf Schwarz, die Sorten drehen sich, jeden Tag eins'], ['B', 'B Der Packzettel: Zeilen, Antippen zeigt die Flasche'], ['C', 'C Noch nicht: von oben, Türchen antippen, die fünf'], ['D', 'D Ohne Kino: ein Brief von Max und Moritz']] },
      { key: 'asatzm', titel: 'Geschenk-Zeile, Handy', optionen: [['ueber', 'Im Fold über dem Inhalt, wie am Desktop'], ['aus', 'Unter dem Fold']] },
      { key: 'afarbe', titel: 'Fold (Runde 10)', optionen: [['hell', 'Hell wie bisher'], ['nacht', 'Nacht: Kopf und Fold auf Schwarz, Schrift weiß']] },
      { key: 'afold', titel: 'Im Fold beim Scrollen (lädt neu)', optionen: [['drei', 'Nur drei Türchen, aus jedem hebt sich eine Flasche'], ['spalt', 'Alle 25 gehen nur einen Spalt auf'], ['heben', 'Alle 25 gehen auf, jede Flasche hebt sich ein Stück'], ['alle', 'Alle 25 Türchen gehen auf, die Flaschen bleiben im Fach'], ['drehen', 'Geschlossen: dreht sich, am Finger drehbar']] },
      { key: 'adreh', titel: 'Drehen: wie er auftritt (lädt neu)', optionen: [['links', 'Kommt von links herein und dreht sich in die Ruhe'], ['oben', 'Fällt von oben herein, dreht sich, setzt weich auf'], ['unten', 'Steigt von unten herauf und dreht sich'], ['heben', 'Steht schon da, hebt sich, dreht sich, setzt auf']] },
      { key: 'akarton', titel: 'Was im Karton ist (lädt neu)', optionen: [['1', '1 Jede Sorte ihr Kniff: beim Einrasten einmal, Antippen noch einmal'], ['2', '2 Rückseite: Antippen dreht die Karte'], ['3', '3 Kühlschrankfach: die Flasche in der Mitte beschlägt'], ['4', '4 Der Abend: Momente statt Sorten, beginnt mit der Uhrzeit'], ['5', '5 Spot: dunkle Bühne, läuft von selbst weiter'], ['6', '6 Eingeschenkt: große Karten, jede Sorte ihr Moment (Standard)']] },
      { key: 'arahmen', titel: 'Eingeschenkt: Film und Text', optionen: [['oben', 'A Film randlos oben, Text darunter (Desktop: Film links)'], ['fenster', 'B Film als Fenster mit Luft, Text oben'], ['voll', 'C Film füllt die Karte, Text im Bild']] },
      { key: 'afuenf', titel: 'Was im Karton ist: fünfmal (lädt neu)', optionen: [['satz', 'a Eigener Satz: Jedes unserer Biere. Fünfmal.'], ['marker', 'b 5× im Marker vor jeder Sorte'], ['beides', 'a und b: der Satz und 5× im Marker']] },
      { key: 'atexte', titel: 'Zwei Sätze in der Geschichte (lädt neu)', optionen: [['alt', 'Wie bisher: Jahrhundertealtes Brauwissen … / Nur natürliche Zutaten.'], ['neu', 'Konkret: seit dem 16. Jahrhundert … / Zutaten, die man kennt.']] },
      { key: 'agratism', titel: 'Im Karton, Handy (Runde 11)', optionen: [['zahlen', 'E Zahlen: 25 · 5 · 1 · 10 €, Antippen zieht eine Lade heraus'], ['fenster', 'F Fenster: die Dinge in einer Reihe, Antippen nennt sie'], ['formel', 'F2 Fenster als Rechnung: 25x Flaschen + Öffner + Gutschein'], ['worte', 'G Worte: zwei Zeilen Text, kein Kasten']] },
    ] : [
      { key: 's', titel: 'Unter dem Kauf', optionen: [['objekt', '1 Das Objekt'], ['bier', '2 Dazu das Bier'], ['zwinkern', '3 Ein Augenzwinkern']] }
    ];
    if (!gruppen.length) return; /* Adventskalender: alles entschieden, kein Regler */
    gruppen.forEach((g) => {
      const fs = document.createElement('fieldset');
      const lg = document.createElement('legend'); lg.textContent = g.titel; fs.append(lg);
      g.optionen.forEach(([wert, beschriftung]) => {
        const lb = document.createElement('label');
        const ip = document.createElement('input'); ip.type = g.mehrfach ? 'checkbox' : 'radio'; ip.name = 'zl-w-' + g.key; ip.value = wert;
        ip.checked = g.mehrfach ? String(prefs[g.key]).split(',').includes(wert) : String(prefs[g.key]) === String(wert);
        ip.addEventListener('change', () => {
          /* Mehrfach (Runde 7): jede Option an oder aus, gespeichert als Liste mit Kommas */
          prefs[g.key] = g.mehrfach ? Array.from(feld.querySelectorAll('input[name="zl-w-' + g.key + '"]:checked')).map((x) => x.value).join(',') : wert;
          /* Bühnen und Geschenk-Varianten der Runden 2 bis 4 gibt es nur ohne Bon: Wer eine wählt, sieht sie sofort */
          if ((g.key === 'buehne' || g.key === 'geschenk') && prefs.fold === 'bon') {
            prefs.fold = 'bisher';
            const f = feld.querySelector('input[name="zl-w-fold"][value="bisher"]'); if (f) f.checked = true;
          }
          if (g.key === 'geschenk' && prefs.buehne !== 'standard') {
            prefs.buehne = 'standard';
            const b = feld.querySelector('input[name="zl-w-buehne"][value="standard"]'); if (b) b.checked = true;
          }
          merke(); if (g.key === 'adarst' || g.key === 'adzeigen' || g.key === 'adatum' || g.key === 'agrossart' || g.key === 'amarker' || g.key === 'aseite' || g.key === 'afold' || g.key === 'adreh' || g.key === 'atexte' || g.key === 'afuenf' || g.key === 'akurz' || g.key === 'akarton') { location.reload(); return; } zeigePrefs(); neuLegen(); einrasten();
        });
        lb.append(ip, document.createTextNode(beschriftung)); fs.append(lb);
      });
      feld.append(fs);
    });
    const p = document.createElement('p'); p.textContent = 'Nur in diesem Browser gespeichert. Im Shop ist es eine Entscheidung.'; feld.append(p);
    knopf.addEventListener('click', () => { const offen = feld.hidden; feld.hidden = !offen; knopf.setAttribute('aria-expanded', String(offen)); });
    document.body.append(knopf, feld);
  };

  /* ---------- Kopf messen: die Bühne beginnt unter dem festen Kopf (wie in B) ---------- */
  let kopf = 0, abstand = 0;
  const kopfMessen = () => {
    const r = root();
    let h = 0, fest = false;
    let el = document.querySelector('.site-header');
    while (el && el !== document.body) {
      const pos = getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') { h = Math.max(0, el.getBoundingClientRect().bottom); fest = pos === 'fixed'; break; }
      el = el.parentElement;
    }
    abstand = fest ? h : 0;
    kopf = h;
    const logo = document.querySelector('.site-header .site-header__logo, .site-header .header-item--logo');
    const korb = document.querySelector('.site-header .js-drawer-open-cart, .site-header [href$="/cart"]');
    const de = html.style;
    de.setProperty('--b-kopf', h + 'px');
    de.setProperty('--b-kopf-fest', h + 'px');
    if (logo) de.setProperty('--b-kante-l', Math.round(logo.getBoundingClientRect().left) + 'px'); else de.removeProperty('--b-kante-l');
    if (korb) de.setProperty('--b-kante-r', Math.round(html.clientWidth - korb.getBoundingClientRect().right) + 'px'); else de.removeProperty('--b-kante-r');
    r.style.setProperty('--b-kopf', h + 'px');
    r.style.setProperty('--b-abstand', abstand + 'px');
  };

  /* ---------- Das Wort füllt die Breite ---------- */
  const mess = document.createElement('canvas').getContext('2d');
  const wortSetzen = () => {
    const r = root();
    const fl = r.querySelector('.zl-o__flaeche');
    const w = Array.from(r.querySelectorAll('[data-zl-o-wort]')).find((x) => getComputedStyle(x).display !== 'none');
    if (!w || !fl) return;
    const cs = getComputedStyle(w);
    mess.font = cs.fontWeight + ' 100px ' + cs.fontFamily; // token-ok: Messgröße, gemessen wird das Verhältnis
    try { mess.letterSpacing = '-3px'; } catch (e) { /* ältere Browser */ } // token-ok: --zl-b-wort-spacing bei der Messgröße 100
    const breite = fl.clientWidth - 2 * (parseFloat(cs.paddingLeft) || 0);
    const text = w.textContent.trim();
    const m = mess.measureText(text).width || text.length * 50;
    /* Höchstens so groß wie in B: am Handy etwa ein Viertel der Bühne, am Desktop bis 260 */
    const max = Math.min(fl.clientHeight * (breitBild() ? 0.3 : 0.22), breitBild() ? 260 : 160); // token-ok: Wortgröße aus der Höhe der Bühne, wie in B
    const fs = Math.max(28, Math.min(max, Math.floor(breite / m * 100))); // token-ok: nie kleiner als eine Headline am Handy
    r.style.setProperty('--o-fs', fs + 'px');
    if (vorlage === 'neukunden') { paketLegen(r, fl, w, fs); glasLegen(r, w); }
  };

  /* ---------- Der Bon: Flaschen aus Glas wie das Mixpaket in B (zl-flasche.js) ----------
     Die Bilder bleiben im Fluss und halten den Platz, die Fläche zeichnet an ihrer Stelle Glas, Bier und Etikett.
     Das Wort dahinter scheint durch. Ziehen dreht alle vier. Ohne WebGL oder in den Bühnen von Runde 1 bis 4 bleiben die Bilder. */
  let glas = null, glasBereit = false;
  const glasLegen = (r, wortEl) => {
    const griff = r.querySelector('[data-zl-o-griff]'), canvas = r.querySelector('[data-zl-o-canvas]');
    const an = html.dataset.zlNFold === 'bon' && griff && canvas && window.zlFlasche;
    if (!an) { if (griff) griff.hidden = true; r.classList.remove('zl-o--glas'); return; }
    const imgs = Array.from(r.querySelectorAll('.zl-o__reihe > img[data-sorte]'));
    if (!glas) {
      let W = {};
      try { W = JSON.parse(document.querySelector('[data-zl-o-flaschen]').textContent); } catch (e) { return; }
      glas = new window.zlFlasche.Reihe(canvas, { bilder: W.bilder, hilfen: W.hilfen, griff, durchscheinen: { staerke: 0.9, hellMin: 1 } }); // token-ok: Wort scheint auch durch die dunklen Hälse
      if (glas.ohne) { glas = null; griff.remove(); return; }
      glas.lade(imgs.map((i) => i.dataset.sorte)).then(() => { glasBereit = true; r.classList.add('zl-o--glas'); });
    }
    griff.hidden = false;
    const c = canvas.getBoundingClientRect();
    glas.setze(imgs.map((i) => {
      const b = i.getBoundingClientRect();
      return { sorte: i.dataset.sorte, x: b.left + b.width / 2 - c.left, y: b.top - c.top, h: b.height, dreh: 0 };
    }));
    glas.hinterText(wortEl);
    if (glasBereit) r.classList.add('zl-o--glas');
  };

  /* Probierpaket wie das Mixpaket in B: die Flaschen so groß, wie Breite und Höhe erlauben, die obere Hälfte des Worts bleibt frei,
     die untere steht hinter den Hälsen. Beim geschlossenen Paket steht das Wort auf dem Deckel. */
  const RATIO = 480 / 1380; // token-ok: Seitenverhältnis der Flaschenbilder zl-g-flasche-*.webp
  const paketLegen = (r, fl, w, fs) => {
    const obj = Array.from(r.querySelectorAll('[data-zl-o-objekt]')).find((x) => x.offsetParent);
    if (!obj) return;
    const cs = getComputedStyle(obj);
    const innen = obj.clientHeight - (parseFloat(cs.paddingBottom) || 0);
    const breite = obj.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    const dicht = parseFloat(getComputedStyle(r).getPropertyValue('--zl-g-gruppe-dicht')) || 6; // token-ok: Ersatz, falls die Variable fehlt
    const fl0 = fl.getBoundingClientRect().top;
    let oben, tief = false;
    if (obj.classList.contains('zl-o__reihe')) {
      const n = obj.querySelectorAll(':scope > img').length || 4;
      /* Geschenke daneben (Variante "Auf der Bühne"): halb so hoch, im Format 3:4, mit 12 Abstand je Seite. Sie teilen sich die Breite */
      const g = 0; /* Geschenke stehen vor den Flaschen, nicht daneben: die Flaschen behalten ihre Größe */
      const gr = parseFloat(getComputedStyle(r).getPropertyValue('--zl-o-geschenk-hoehe')) || 0.5; // token-ok: Ersatz, falls die Variable fehlt
      const rand = 24; // token-ok: --zl-space-2 links und rechts eines Geschenks
      const bon = html.dataset.zlNFold === 'bon';
      const rechnung = html.dataset.zlNBuehne === 'rechnung' && !bon;
      tief = bon && !breitBild(); /* Bon am Handy: das Wort steht auf derselben Höhe wie bei einer Sorte in B (Moritz, 05.10.2026) */
      const frei = rechnung ? 1.0 : tief ? 0.1 : 0.55; // token-ok: bei der Rechnung steht die Summe ganz über den Flaschen, sonst die obere Hälfte des Worts
      const h = Math.max(80, Math.min(innen - frei * fs, (breite + 2 * n * dicht - g * rand) / (n * RATIO + g * gr * 0.75))); // token-ok: obere Hälfte des Worts frei, 0,75 ist das Format 3:4
      obj.style.setProperty('--o-flasche-h', Math.round(h) + 'px');
      const img = obj.querySelector(':scope > img');
      const flTop = img ? img.getBoundingClientRect().top : obj.getBoundingClientRect().bottom - h;
      oben = flTop - fl0 + (rechnung ? -0.45 * fs : tief ? 0.33 * h : (breitBild() ? 0.07 : 0.02) * h); // token-ok: Rechnung: die Summe sitzt auf den Kronkorken. Bon am Handy: Mitte des Worts auf einem Drittel der Flasche wie bei einer Sorte in B, dort ist das Glas hell und das Wort scheint durch. Sonst auf Höhe der Kronkorken wie beim Mixpaket in B
      r.style.setProperty('--o-etikett-top', Math.round(flTop - fl0 + 0.12 * h) + 'px'); // token-ok: Etikett der Geschenke liegt auf den Schultern der Flaschen
    } else {
      const k = obj.querySelector('.zl-o__paket');
      oben = k ? k.getBoundingClientRect().top - fl0 - 0.4 * fs : 0; // token-ok: das Wort steht auf dem Deckel, nur die Unterlängen dahinter
    }
    /* Bon am Handy genau wie B (zl-produkt-buehne.js): Mitte des Worts 0,475 Schriftgrößen unter seiner Oberkante, gemessen an der
       Zeile selbst, ohne den Innenabstand über dem Wort */
    const versatz = tief ? 0.475 * fs + (parseFloat(getComputedStyle(w).paddingTop) || 0) : 0.5 * fs; // token-ok: wie in B
    r.style.setProperty('--o-wort-top', Math.max(6, Math.round(oben - versatz)) + 'px'); // token-ok: Mitte des Worts, nie über der Fläche
  };

  /* ---------- Kurzer Bildschirm: Bühne in fester Höhe, alles scrollt normal (wie in B) ---------- */
  const MIN = 220; // token-ok: wie in B, darunter passt das Objekt nicht mehr neben den Kauf
  const kurzPruefen = () => {
    const r = root(), kauf = r.querySelector('[data-zl-b-kauf]');
    const frei = window.innerHeight - kopf - (breitBild() || !kauf ? 0 : kauf.offsetHeight);
    r.classList.toggle('zl-b--kurz', frei < MIN);
  };

  /* ---------- Leiste, die mitkommt ---------- */
  const leisteEl = document.querySelector('[data-zl-o-leiste]');
  if (leisteEl) document.body.append(leisteEl);
  const leiste = () => {
    if (!leisteEl) return;
    const knopf = root().querySelector('[data-zl-b-knopf]');
    if (!knopf) return;
    const r = knopf.getBoundingClientRect();
    const fuss = document.querySelector('.site-footer, footer');
    const amEnde = fuss && fuss.getBoundingClientRect().top < window.innerHeight;
    const zeigen = !amEnde && (r.bottom < kopf || r.top > window.innerHeight);
    if (leisteEl.hidden !== !zeigen) leisteEl.hidden = !zeigen;
  };
  const leisteDaten = () => {
    if (!leisteEl) return;
    let d = {};
    try { d = JSON.parse(root().querySelector('[data-zl-o-daten]').textContent); } catch (e) { return; }
    const n = leisteEl.querySelector('[data-zl-o-leiste-name]'), p = leisteEl.querySelector('[data-zl-o-leiste-preis]');
    if (n) n.textContent = d.name || '';
    if (p) p.textContent = d.preis || '';
  };
  if (leisteEl) {
    leisteEl.querySelector('[data-zl-o-leiste-knopf]').addEventListener('click', () => {
      const r = root();
      const y = window.scrollY + r.getBoundingClientRect().top - (abstand ? 0 : kopf);
      window.scrollTo({ top: y, behavior: reduziert() ? 'auto' : 'smooth' });
      const ziel = r.querySelector('.zl-b__menge.is-an') || r.querySelector('[data-zl-b-knopf]');
      if (ziel) setTimeout(() => ziel.focus({ preventScroll: true }), reduziert() ? 0 : 600); // token-ok: nach dem weichen Scrollen
    });
  }

  /* ---------- In den Warenkorb: Formular des Themes ---------- */
  const formular = () => {
    const f = root().querySelector('[data-zl-b-form]'); if (!f || f.dataset.zlBAjax) return;
    const los = () => {
      if (window.theme && window.theme.AjaxProduct && !f.dataset.zlBAjax) { f.dataset.zlBAjax = '1'; new window.theme.AjaxProduct(f, '[data-add-to-cart]'); return true; }
      return false;
    };
    if (!los()) { let n = 0; const t = setInterval(() => { if (los() || ++n > 50) clearInterval(t); }, 100); } // token-ok: warten, bis das Theme bereit ist
  };

  /* ---------- Menge neben dem Button, alle Vorlagen der Bühne (Moritz, 08.10.2026) ----------
     Minus und Plus ändern die Zahl (1 bis 10), die mit dem Formular als quantity in den Warenkorb geht. Die Versandzeile in Deutschland
     (data-zl-o-versand) wechselt auf versandkostenfrei, sobald Menge mal Preis die Grenze erreicht, und zurück.
     Antippen gibt spürbar nach: der Knopf wird kleiner und dunkler und federt beim Loslassen zurück (CSS). Wo das Telefon es kann
     (Android), kommt ein ganz kurzes Rütteln dazu. Mit der Tastatur zeigt eine Klasse denselben Druck. */
  document.addEventListener('pointerdown', (e) => {
    const k = e.target.closest('[data-zl-o-menge-schritt]'); if (!k || k.disabled) return;
    try { if (navigator.vibrate) navigator.vibrate(8); } catch (err) { /* ohne Rütteln */ } // token-ok: ein kurzer Tick
  }, { passive: true });
  document.addEventListener('keydown', (e) => {
    const k = e.target.closest && e.target.closest('[data-zl-o-menge-schritt]'); if (!k || (e.key !== 'Enter' && e.key !== ' ')) return;
    k.classList.add('ist-gedrueckt'); setTimeout(() => k.classList.remove('ist-gedrueckt'), 150); // token-ok: so lang wie ein Druck
  });
  document.addEventListener('click', (e) => {
    const k = e.target.closest('[data-zl-o-menge-schritt]'); if (!k) return;
    const box = k.closest('[data-zl-o-menge]'), zahl = box && box.querySelector('input[name="quantity"]'); if (!zahl) return;
    const min = parseInt(zahl.min, 10) || 1, max = parseInt(zahl.max, 10) || 10; // token-ok: Grenzen aus dem Feld
    const neu = Math.min(max, Math.max(min, (parseInt(zahl.value, 10) || 1) + parseInt(k.dataset.zlOMengeSchritt, 10)));
    zahl.value = String(neu);
    box.querySelectorAll('[data-zl-o-menge-schritt]').forEach((b) => { const s = parseInt(b.dataset.zlOMengeSchritt, 10); b.disabled = s < 0 ? neu <= min : neu >= max; });
    const anzeige = box.querySelector('[data-zl-o-menge-zahl]');
    if (anzeige) anzeige.textContent = String(neu);
    const v = (box.closest('[data-zl-o]') || document).querySelector('[data-zl-o-versand]');
    if (v) {
      if (!('vorher' in v.dataset)) v.dataset.vorher = v.textContent;
      const frei = neu * (parseInt(v.dataset.preis, 10) || 0) >= (parseInt(v.dataset.grenze, 10) || Infinity);
      v.textContent = frei ? v.dataset.frei : v.dataset.vorher;
    }
  });

  /* ---------- Objekt: Bilder zählen beim Wischen ---------- */
  const bilderZaehlen = () => {
    const r = root(), reihe = r.querySelector('[data-zl-o-bilder]'), zahl = r.querySelector('[data-zl-o-zahl]');
    if (!reihe || !zahl) return;
    let raf = 0;
    reihe.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = 0; zahl.textContent = String(Math.round(reihe.scrollLeft / Math.max(1, reihe.clientWidth)) + 1); });
    }, { passive: true });
  };

  /* ---------- Gutschein: Betrag wechseln ohne Neuladen ---------- */
  let holeToken = null;
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('[data-zl-o-betrag]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    if (a.classList.contains('is-an')) return;
    a.closest('nav').querySelectorAll('[data-zl-o-betrag]').forEach((x) => { x.classList.toggle('is-an', x === a); x.removeAttribute('aria-current'); });
    a.setAttribute('aria-current', 'page');
    const token = {}; holeToken = token;
    const wechsel = root().querySelector('[data-zl-b-wechsel]');
    if (wechsel) wechsel.classList.add('is-laedt');
    try {
      const r = await fetch('/products/' + a.dataset.zlOBetrag + '?view=zl-standard&section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' });
      if (!r.ok || holeToken !== token) throw new Error('nicht geladen');
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const neu = doc.querySelector('[data-zl-o]');
      if (!neu) throw new Error('leer');
      root().innerHTML = neu.innerHTML;
      try {
        const u = new URL(location.href); u.pathname = a.pathname; u.searchParams.set('view', 'zl-standard');
        history.replaceState(history.state, '', u.toString());
      } catch (err) { /* Adresse bleibt */ }
      formular(); bilderZaehlen(); leisteDaten(); neuLegen();
    } catch (err) {
      location.href = a.href;
    }
  });

  /* ---------- Geschenke, Variante "Etikett": Antippen klappt auf, noch einmal Tippen oder Escape schließt ---------- */
  const feldZu = (k, f) => { k.setAttribute('aria-expanded', 'false'); f.hidden = true; f.classList.remove('is-auf'); };
  document.addEventListener('click', (e) => {
    const k = e.target.closest('[data-zl-o-etikett]');
    if (!k) return;
    const f = document.getElementById(k.getAttribute('aria-controls'));
    if (!f) return;
    if (k.getAttribute('aria-expanded') === 'true') { feldZu(k, f); return; }
    k.setAttribute('aria-expanded', 'true'); f.hidden = false; f.classList.add('is-auf');
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-zl-o-etikett][aria-expanded="true"]').forEach((k) => { const f = document.getElementById(k.getAttribute('aria-controls')); if (f) { feldZu(k, f); k.focus(); } });
  });

  /* ---------- Was du bekommst: Fach für Fach einrasten, wenn es ins Bild kommt ---------- */
  let beobachter = null;
  const einrasten = () => {
    if (beobachter) beobachter.disconnect();
    const teile = document.querySelectorAll('.zl-n [data-zl-n-fach], .zl-n .zl-n__rechnung--gross');
    if (!teile.length || reduziert() || !('IntersectionObserver' in window)) return;
    beobachter = new IntersectionObserver((eintraege) => {
      eintraege.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('is-da'); beobachter.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -25% 0px' }); // token-ok: rastet ein, wenn das Fach ein Viertel über dem unteren Rand ist
    teile.forEach((t) => {
      if (t.classList.contains('is-da') || !t.offsetParent) return;
      const r = t.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.75) { t.classList.add('is-da'); return; } // token-ok: schon im Bild, dann steht es
      t.classList.add('is-bereit');
      beobachter.observe(t);
    });
  };

  /* ---------- Adventskalender: passt der Kauf unter das Wort? ----------
     Am Desktop steht der Kauf unten rechts auf der Bühne. Mit den beiden Karten ist er so hoch, dass er auf flacheren Bildschirmen
     (MacBook 13 und 14 Zoll) ins Wort ragt. Dann werden die Karten zu einer Liste in einer Fläche (zl-a--eng, wie Regler B), reicht
     auch das nicht, zu Zeilen ohne Bilder (zl-a--eng2, wie Regler D).
     Gemessen von der Grundlinie des Worts, Abstand Gruppenwechsel. */
  const engPruefen = () => {
    const r = root(); if (!r || vorlage !== 'advent') return;
    r.classList.remove('zl-a--eng', 'zl-a--eng2');
    if (!breitBild() || (prefs.agratis !== 'karten' && prefs.agratis !== 'liste')) return;
    const w = Array.from(r.querySelectorAll('[data-zl-o-wort]')).find((x) => getComputedStyle(x).display !== 'none');
    const k = r.querySelector('[data-zl-b-kauf]'); if (!w || !k) return;
    const marke = document.createElement('span');
    marke.style.cssText = 'display:inline-block;width:0;height:0;vertical-align:baseline'; // token-ok: unsichtbare Marke auf der Grundlinie
    (w.querySelector('[data-hinten-zeile]') || w).append(marke);
    const grund = marke.getBoundingClientRect().bottom; marke.remove();
    const abstand = parseFloat(getComputedStyle(r).getPropertyValue('--zl-gap-groups')) || 48; // token-ok: Ersatz, falls der Token fehlt
    const passt = () => k.getBoundingClientRect().top >= grund + abstand;
    if (passt()) return;
    if (prefs.agratis === 'karten') { r.classList.add('zl-a--eng'); if (passt()) return; }
    r.classList.add('zl-a--eng2');
  };
  /* ---------- Start ---------- */
  /* Adventskalender, Plus "neben": das Plus steht auf der Bühne links vom Kauf, auf der Mitte der Karten */
  const plusLegen = () => {
    const r = root(); if (!r || vorlage !== 'advent') return;
    const k = r.querySelector('.zl-a__karten'), plus = r.querySelector('.zl-a__plus--neben');
    const bezug = plus && plus.offsetParent; if (!k || !bezug) return;
    const rb = bezug.getBoundingClientRect(), kb = k.getBoundingClientRect();
    /* Gemessen am Karton, wie er im ersten Bild steht (data-zl-a-inhalt), nicht am Kasten des Bilds mit seinem weißen Rand.
       Waagerecht mitten zwischen Karton und Kauf, senkrecht auf der Linie von der Mitte des Kartons zur Mitte der Karten. */
    const bild = r.querySelector('[data-zl-a-bild]'), kauf = r.querySelector('[data-zl-b-kauf]');
    const kartenMitte = { x: kb.left + kb.width / 2, y: kb.top + kb.height / 2 };
    if (bild && kauf && breitBild()) {
      const bb = bild.getBoundingClientRect(), nw = bild.naturalWidth || 1067, nh = bild.naturalHeight || 1121; // token-ok: Größe der Bilder, falls noch nicht geladen
      const sk = Math.min(bb.width / nw, bb.height / nh), w = nw * sk, h = nh * sk;
      const op = getComputedStyle(bild).objectPosition.split(' ').map((v) => parseFloat(v) / 100);
      const x0 = bb.left + (bb.width - w) * (isNaN(op[0]) ? 0.5 : op[0]), y0 = bb.top + (bb.height - h) * (isNaN(op[1]) ? 0.5 : op[1]);
      const [il, it, ir, ib] = (bild.dataset.zlAInhalt || '0 0 1 1').split(' ').map(Number);
      const karton = { l: x0 + il * w, t: y0 + it * h, r: x0 + ir * w, b: y0 + ib * h };
      const px = (karton.r + kauf.getBoundingClientRect().left) / 2;
      const kx = (karton.l + karton.r) / 2, ky = (karton.t + karton.b) / 2;
      const py = ky + (kartenMitte.y - ky) * ((px - kx) / Math.max(1, kartenMitte.x - kx));
      r.style.setProperty('--a-plus-x', Math.round(px - rb.left) + 'px');
      r.style.setProperty('--a-plus-mitte', Math.round(py - rb.top) + 'px');
    } else r.style.removeProperty('--a-plus-x');
  };
  /* ---------- Adventskalender: die Bildfolge hängt am Scrollen ----------
     76 gerenderte Bilder, die 25 Türchen gehen nacheinander auf. Am Desktop steht die Bühne fest, solange der Scrollweg läuft
     (--zl-b-scroll). Am Handy, wenn Bühne und Kauf nicht in eine Höhe passen (zl-b--kurz), läuft die Folge, während der Kalender
     nach oben wandert, und ist fertig, bevor er aus dem Bild ist. Die Folge holt den Daumen weich auf, auch rückwärts.
     Das Bild darunter bestimmt Größe und Lage (CSS, Regler), die Fläche zeichnet genau dorthin. Reduzierte Bewegung: das erste Bild. */
  const folge = (() => {
    const cv = vorlage === 'advent' ? root0.querySelector('[data-zl-a-folge]') : null;
    if (!cv) return { legen() {}, };
    const bild = root0.querySelector('[data-zl-a-bild]');
    const huelle = cv.parentElement;
    const n = parseInt(cv.dataset.anzahl, 10) || 1;
    let satz = '', bilder = [], soll = 0, ist = 0, laufend = 0, start = 0, laenge = 1;
    const url = (k, i) => cv.dataset[k].replace(/-01\.webp/, '-' + String(i + 1).padStart(2, '0') + '.webp');
    /* Runde 6, Regler "Kalender": live in 3D (Standard) oder die gerenderte Bildfolge. In 3D lädt die Folge nur ihr erstes Bild als
       Platzhalter, bis das Modell steht. Ohne WebGL oder wenn das Laden scheitert, lädt sie alle Bilder wie bisher. */
    const dreiFl = root0.querySelector('[data-zl-a-drei]');
    let drei = null, dreiLaeuft = false;
    /* Lage, Netz und Standbild teilen sich der erste Bildschirm und dieses Skript: snippets/zl-a-netz.liquid (window.zlAKalender) */
    const K = window.zlAKalender || { lage: () => null, px: () => ({}), ruheLegen: () => {}, netz: () => null, ersatz: () => {}, ersatzMs: 5000, datenMs: 10000, rand: 0.15 }; // token-ok: Ersatz, falls der Baustein fehlt
    const webgl = () => { try { const c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl'))); } catch (e) { return false; } };
    const willDrei = () => !!dreiFl && prefs.adarst !== 'folge' && webgl();
    const dreiStarten = () => {
      if (dreiLaeuft) return; dreiLaeuft = true;
      const inhalt = (bild.dataset.zlAInhalt || '0 0 1 1').split(' ').map(Number);
      /* Runde 10, Regler "Im Fold": alle 25 Türchen oder nur drei (andeuten). Etiketten aus den Daten der echten Flaschen. */
      const opt = { flaeche: dreiFl, glb: cv.dataset.glb, hdr: cv.dataset.hdr, schatten: cv.dataset.schatten, kronkorken: cv.dataset.kronkorken, teile: cv.dataset.teile, inhalt, rand: K.rand };
      const SORTEN = ['unfiltered', 'pils', 'hell', 'wheat', 'lemon'];
      if (prefs.afold === 'drei') {
        opt.drei = [{ nr: 13, sorte: 'unfiltered' }, { nr: 19, sorte: 'pils' }, { nr: 22, sorte: 'hell' }]; /* Türchen auf der Seite zur Kamera, damit man hineinsieht */
      } else {
        /* Alle 25: fünf Sorten in jeder Reihe (Moritz, 08.10.2026), je Reihe um eine versetzt, damit keine Sorte in einer Spalte steht */
        opt.alle = { art: prefs.afold === 'alle' ? 'liegen' : prefs.afold, sorten: Array.from({ length: 25 }, (_, i) => SORTEN[(Math.floor(i / 5) + i % 5) % 5]) };
      }
      try {
        const W = JSON.parse(document.querySelector('[data-zl-o-flaschen]').textContent);
        opt.etiketten = {}; SORTEN.forEach((k) => { if (W.bilder[k]) opt.etiketten[k] = W.bilder[k].etikett; });
      } catch (e) { /* ohne Etiketten geht es auch */ }
      opt.etikettMaske = cv.dataset.etikettMaske;
      /* Stellung "drehen" (Moritz, 08.10.2026): der geschlossene Kalender dreht sich, eigenes Modul, gegriffen wird nur auf dem Bild */
      const drehen = prefs.afold === 'drehen' && cv.dataset.drehen;
      if (drehen) { opt.griff = bild; opt.auftritt = prefs.adreh || 'links'; huelle.classList.add('ist-drehen'); }
      /* Schweres im ersten Bildschirm (CLAUDE.md). Entschieden wird am Modell selbst (Moritz, 15.10.2026: bei schnellem Netz kam
         nach 3 bis 4 s das Standbild statt der Animation). Andere Dateien als Maß irren: Nach einem Go-live sind neue Dateien am
         Server noch kalt und kommen langsam, nach einem Wechsel von der Startseite liegt fast alles im Zwischenspeicher. Deshalb lädt
         das Modell selbst an, schon beim Lesen der Seite (snippets/zl-a-netz.liquid, glbLaden), und nach den ersten 0,3 s seiner
         Daten rechnet die Seite hoch, wann es fertig wäre. Steht es so bis
         --zl-a-ersatz-daten (10 s nach dem Aufruf), kommt die Animation, sonst bricht das Laden ab und das Standbild steht. Kommt das
         Modell trotzdem erst nach dieser Zeit, steht das Standbild, und das Modell wird nicht mehr gezeigt, damit nichts umspringt. */
      if (drehen && (K.langsam || K.probe)) { K.langsam = true; K.ersatz(); return; }
      let zuSpaet = false;
      const ersatzZeigen = () => { if (drei) return; zuSpaet = true; K.ersatz(); };
      const ersatz = drehen ? setTimeout(ersatzZeigen, Math.max(0, K.datenMs - performance.now())) : 0;
      const ladung = drehen ? (K.ladung || (K.glbLaden && K.glbLaden())) : null; /* startet schon beim Lesen der Seite (zl-a-netz.liquid) */
      (ladung ? ladung.weiter : Promise.resolve(true))
        .then((weiter) => {
          if (!weiter) { K.langsam = true; clearTimeout(ersatz); ersatzZeigen(); return null; }
          /* Steht fest, dass das Modell kommt, starten Code, Licht und Decoder sofort, parallel zum Rest des Modells (Schweres leicht
             bauen, Punkt 6). Die Adresse des Modells reicht die Ladung nach, wenn es ganz da ist. */
          if (ladung) { opt.glb = ladung.url.then((u) => u || cv.dataset.glbErst || cv.dataset.glb); opt.basis = cv.dataset.drei.slice(0, cv.dataset.drei.lastIndexOf('/') + 1); /* Draco-Decoder liegt im Theme neben den Modulen, das Modell in den Shopify-Dateien */ }
          return import(drehen ? cv.dataset.drehen : cv.dataset.drei)
            .then((m) => m.starten(opt))
            .then((d) => {
              if (zuSpaet) { if (d && d.weg) d.weg(); return; }
              clearTimeout(ersatz);
              drei = d; K.drei = true; performance.mark('zl-a-drei-da'); document.dispatchEvent(new CustomEvent('zl:a-erster')); huelle.zlDrei = d; /* zum Nachmessen im Browser (kante) */ huelle.classList.add('ist-drei'); zeichnen();
            });
        })
        .catch(() => { document.dispatchEvent(new CustomEvent('zl:a-ruhig')); huelle.classList.remove('ist-drei', 'ist-ruhe'); huelle.classList.add('ohne-3d'); const k = satz; eins(k, 0).then(() => { huelle.classList.add('ist-folge'); zeichnen(); restLaden(k); }); });
    };
    const eins = (k, i) => new Promise((ok) => { const im = new Image(); im.decoding = 'async'; im.onload = () => { if (satz === k) bilder[i] = im; ok(); }; im.onerror = () => ok(); im.src = url(k, i); });
    const restLaden = async (k) => {
      for (let i = 1; i < n; i++) { if (satz !== k) return; if (!bilder[i]) await eins(k, i); if (Math.round(ist * (n - 1)) >= i - 1) zeichnen(); }
    };
    const laden = (k) => {
      satz = k; bilder = new Array(n).fill(null);
      /* In 3D bleibt das Bild stehen, bis das Modell steht: es ist das erste Bild des Modells selbst, deshalb springt nichts
         (Moritz, 08.10.2026: der Karton zuckte und drehte sich, weil das erste Bild der gerenderten Folge anders stand) */
      if (huelle.classList.contains('ist-ruhe')) return; /* langsames Netz: das Standbild steht, keine Bildfolge */
      if (willDrei()) { dreiStarten(); return; }
      huelle.classList.add('ohne-3d'); /* ohne 3D steht das Bild, auch in der Stellung drehen */
      document.dispatchEvent(new CustomEvent('zl:a-ruhig'));
      eins(k, 0).then(() => { huelle.classList.add('ist-folge'); zeichnen(); }).then(() => restLaden(k));
    };
    const ziel = () => {
      if (reduziert()) return 0;
      const y = window.scrollY - start;
      return Math.min(1, Math.max(0, y / laenge));
    };
    const zeichnen = () => {
      if (drei && bild) {
        const l = K.lage(); if (!l) return;
        Object.assign(dreiFl.style, K.px(l));
        drei.zeichnen(ist, l.width, l.height);
        return;
      }
      if (huelle.classList.contains('ist-ruhe')) { K.ruheLegen(); return; }
      const ctx = cv.getContext('2d'); if (!ctx || !bild) return;
      let i = Math.round(ist * (n - 1));
      let im = bilder[i];
      for (let d = 1; !im && d < n; d++) im = bilder[i - d] || bilder[i + d];
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const hb = cv.getBoundingClientRect(), bb = bild.getBoundingClientRect();
      const w = Math.round(hb.width * dpr), h = Math.round(hb.height * dpr);
      if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
      ctx.clearRect(0, 0, w, h);
      if (!im) return;
      const pos = getComputedStyle(bild).objectPosition.split(' ').map((v) => parseFloat(v) / 100);
      const sk = Math.min(bb.width / im.naturalWidth, bb.height / im.naturalHeight);
      const dw = im.naturalWidth * sk, dh = im.naturalHeight * sk;
      const x = bb.left - hb.left + (bb.width - dw) * (isNaN(pos[0]) ? 0.5 : pos[0]);
      const y = bb.top - hb.top + (bb.height - dh) * (isNaN(pos[1]) ? 1 : pos[1]);
      ctx.drawImage(im, x * dpr, y * dpr, dw * dpr, dh * dpr);
    };
    const schritt = () => {
      soll = ziel();
      const neu = ist + (soll - ist) * 0.22; // token-ok: weiches Aufholen je Bild, kein Nachschwingen
      ist = Math.abs(soll - neu) < 0.001 ? soll : neu;
      const vor = Math.round(ist * (n - 1));
      zeichnen();
      laufend = ist !== soll ? requestAnimationFrame(schritt) : 0;
      return vor;
    };
    window.addEventListener('scroll', () => { if (!laufend) laufend = requestAnimationFrame(schritt); }, { passive: true });
    return {
      legen() {
        const k = breitBild() ? 'd' : 'm';
        if (k !== satz) laden(k);
        const r = root(); const rb = r.getBoundingClientRect();
        start = rb.top + window.scrollY;
        if (r.classList.contains('zl-b--kurz')) { laenge = Math.max(1, huelle.getBoundingClientRect().height * 0.75); } // token-ok: fertig, bevor ein Viertel des Kalenders aus dem Bild ist
        else { laenge = Math.max(1, parseFloat(getComputedStyle(r).height) - parseFloat(getComputedStyle(r.querySelector('.zl-b__buehne')).height)); }
        ist = soll = ziel(); huelle.classList.add('ist-lage'); zeichnen();
      }
    };
  })();
  /* Adventskalender am Handy: wo der Karton steht. Zwischen der Grundlinie des Worts und den Beigaben, oben und unten mit
     Gruppenwechsel, so groß wie dort Platz ist. Höchstens so breit, dass der Karton (erstes Bild, data-zl-a-inhalt) innerhalb
     der Bildschirmbreite bleibt, dann auf der Mitte zwischen Wort und Beigaben. Regler "Wort hinter dem Karton": die Spitze
     reicht gut halb ins Wort. Gilt, solange alles in den ersten Bildschirm passt (nicht zl-b--kurz). */
  const kalenderLegen = () => {
    const r = root(); if (!r || vorlage !== 'advent') return;
    const huelle = r.querySelector('.zl-a__kalender'), bild = r.querySelector('[data-zl-a-bild]');
    const wort = r.querySelector('[data-hinten-zeile]'), beig = r.querySelector('.zl-a__beigaben'), fl = r.querySelector('.zl-b__flaeche');
    if (!huelle || !bild || !wort || !beig || !fl) return;
    huelle.classList.remove('ist-gelegt');
    r.style.removeProperty('--a-kauf-top');
    if (r.classList.contains('zl-b--kurz')) return;
    if (breitBild()) { kalenderLegenDesktop(r, huelle, bild, wort, fl); return; }
    const cs = getComputedStyle(r);
    const fs = parseFloat(cs.getPropertyValue('--o-fs')) || 40; // token-ok: Ersatz, bis das Wort gesetzt ist
    const tief = parseFloat(cs.getPropertyValue('--zl-a-wort-tief')) || 0.58; // token-ok: Ersatz, falls der Token fehlt
    const g = parseFloat(cs.getPropertyValue('--zl-gap-groups')) || 36; // token-ok: Ersatz, falls der Token fehlt
    const marke = document.createElement('span');
    marke.style.cssText = 'display:inline-block;width:0;height:0;vertical-align:baseline'; // token-ok: unsichtbare Marke auf der Grundlinie
    wort.append(marke); const grund = marke.getBoundingClientRect().bottom; marke.remove();
    const [il, it, ir, ib] = (bild.dataset.zlAInhalt || '0 0 1 1').split(' ').map(Number);
    const nw = bild.naturalWidth || 1067, nh = bild.naturalHeight || 1121; // token-ok: Größe der Bilder
    const oben = prefs.awort === 'hinter' ? grund - fs * tief : grund + g;
    /* Unter dem Karton zu dem, was drin ist, ein Paar (18 statt 36, Moritz 06.10.2026: weniger Weiß, mehr Kalender) */
    const paar = parseFloat(cs.getPropertyValue('--zl-gap-pair')) || 18; // token-ok: Ersatz, falls der Token fehlt
    /* Steht eine Zeile unter dem Karton (Geschenk-Zeile), endet der Karton über ihr */
    const zeilen = ['.zl-a__satz', '.zl-a__satz-kauf'].map((q) => r.querySelector(q)).filter((z) => z && z.offsetParent);
    const bis = Math.min(beig.getBoundingClientRect().top, ...zeilen.map((z) => z.getBoundingClientRect().top));
    const unten = bis - paar;
    let h = Math.max(0, unten - oben) / (ib - it);
    const breiteRand = window.innerWidth - 2 * (parseFloat(cs.getPropertyValue('--zl-gutter')) || 18); // token-ok: Ersatz für den Seitenrand
    const wKarton = Math.min(breiteRand / (ir - il), window.innerWidth); /* der Karton hält die Kanten des Seitenrands */
    let w = h * nw / nh;
    let kTop = oben;
    if (w > wKarton) { w = wKarton; h = w * nh / nw; kTop = (oben + unten) / 2 - (ib - it) * h / 2; }
    if (prefs.awort === 'hinter') kTop = Math.min(kTop, oben);
    const hb = huelle.getBoundingClientRect();
    const x = window.innerWidth / 2 - ((il + ir) / 2) * w - hb.left;
    const y = kTop - it * h - hb.top;
    huelle.style.setProperty('--a-l', Math.round(x) + 'px');
    huelle.style.setProperty('--a-t', Math.round(y) + 'px');
    huelle.style.setProperty('--a-w', Math.round(w) + 'px');
    huelle.style.setProperty('--a-h', Math.round(h) + 'px');
    huelle.style.setProperty('--a-cv-oben', Math.round(hb.top - fl.getBoundingClientRect().top) + 'px');
    huelle.classList.add('ist-gelegt');
  };
  /* Desktop (Runde 11, Moritz 07.10.2026: Karton und Kauf hingen zu weit unter dem Wort). Regler "Desktop":
     ruhig   Der Karton füllt die Höhe zwischen Wort und Unterkante (36 zum Wort, 36 zum Rand), steht mittig zwischen Rand und Kauf,
             der Kauf steht auf seiner Mitte. Eine Zeile: Karton und Kauf auf einer Mitte.
     hinter  Wie ruhig, aber der Karton reicht mit seiner Spitze ins Wort (wie die Hälse der Flaschen beim Mixpaket).
     unten   Wie bisher: Karton und Kauf stehen an der Unterkante.
     Das Bild wird absolut gelegt (--a-l/t/w/h wie am Handy), der Kauf bekommt --a-kauf-top. */
  const kalenderLegenDesktop = (r, huelle, bild, wort, fl) => {
    if (prefs.adesk === 'unten') return;
    const kauf = r.querySelector('[data-zl-b-kauf]'), buehne = r.querySelector('.zl-b__buehne');
    if (!kauf || !buehne) return;
    const cs = getComputedStyle(r);
    const fs = parseFloat(cs.getPropertyValue('--o-fs')) || 40; // token-ok: Ersatz, bis das Wort gesetzt ist
    const tief = parseFloat(cs.getPropertyValue('--zl-a-wort-tief')) || 0.58; // token-ok: Ersatz, falls der Token fehlt
    const g = parseFloat(cs.getPropertyValue('--zl-gap-groups')) || 36; // token-ok: Ersatz, falls der Token fehlt
    const rand = parseFloat(cs.getPropertyValue('--zl-gutter')) || 36; // token-ok: Ersatz, falls der Token fehlt
    const marke = document.createElement('span');
    marke.style.cssText = 'display:inline-block;width:0;height:0;vertical-align:baseline'; // token-ok: unsichtbare Marke auf der Grundlinie
    wort.append(marke); const grund = marke.getBoundingClientRect().bottom; marke.remove();
    const [il, it, ir, ib] = (bild.dataset.zlAInhalt || '0 0 1 1').split(' ').map(Number);
    const nw = bild.naturalWidth || 1067, nh = bild.naturalHeight || 1121; // token-ok: Größe der Bilder
    const bb = buehne.getBoundingClientRect(), hb = huelle.getBoundingClientRect();
    const oben = prefs.adesk === 'hinter' ? grund - fs * tief : grund + g;
    /* Steht links unten die Geschenk-Zeile, endet der Karton 36 über ihr, sonst 36 über dem Rand */
    const zeile = r.querySelector('.zl-a__satz');
    const unten = zeile && zeile.offsetParent && zeile.textContent.trim() ? zeile.getBoundingClientRect().top - g : bb.bottom - rand;
    let h = Math.max(0, unten - oben) / (ib - it);
    let w = h * nw / nh;
    /* Der Karton steht mittig zwischen dem Rand links (Kante des Logos) und dem Kauf rechts, immer (Moritz, 08.10.2026, ohne Zeichen
       dazwischen). Zu beiden Seiten bleibt mindestens ein Gruppenwechsel Luft. */
    const kb = kauf.getBoundingClientRect();
    const feldL = hb.left, feldR = kb.left > hb.left ? kb.left : hb.right;
    const wKarton = Math.max(0, feldR - feldL - 2 * g);
    if (w * (ir - il) > wKarton) { w = wKarton / (ir - il); h = w * nh / nw; }
    const kTop = (oben + unten) / 2 - (ib - it) * h / 2;
    const x = (feldL + feldR) / 2 - hb.left - ((il + ir) / 2) * w; /* die Mitte des Kartons auf der Mitte des Felds */
    const y = kTop - it * h - hb.top;
    huelle.style.setProperty('--a-l', Math.round(x) + 'px');
    huelle.style.setProperty('--a-t', Math.round(y) + 'px');
    huelle.style.setProperty('--a-w', Math.round(w) + 'px');
    huelle.style.setProperty('--a-h', Math.round(h) + 'px');
    huelle.style.setProperty('--a-cv-oben', Math.round(hb.top - fl.getBoundingClientRect().top) + 'px');
    huelle.classList.add('ist-gelegt');
    /* Der Kauf auf der Mitte des Kartons, nie über das Wort hinaus und nie unter den Rand */
    const mitte = (oben + unten) / 2;
    const kh = kauf.getBoundingClientRect().height;
    const top = Math.max(grund + g, Math.min(mitte - kh / 2, unten - kh));
    r.style.setProperty('--a-kauf-top', Math.round(top - bb.top) + 'px');
  };
  /* Runde 11, kurze Fassungen von "Im Karton" am Handy: Zahlen mit Lade, Fenster mit Wort beim Antippen */
  const kurz = () => {
    const r = root(); if (!r || vorlage !== 'advent') return;
    const lade = r.querySelector('[data-zl-a-lade]');
    const zahlen = Array.from(r.querySelectorAll('[data-zl-a-zahl]'));
    zahlen.forEach((z) => z.addEventListener('click', () => {
      const war = z.getAttribute('aria-expanded') === 'true';
      zahlen.forEach((x) => x.setAttribute('aria-expanded', 'false'));
      r.querySelectorAll('[data-zl-a-lade-teil]').forEach((t) => t.classList.remove('ist-dran'));
      if (war) { lade.classList.remove('ist-offen'); return; }
      z.setAttribute('aria-expanded', 'true');
      const t = r.querySelector('[data-zl-a-lade-teil="' + z.dataset.zlAZahl + '"]'); if (t) t.classList.add('ist-dran');
      lade.classList.add('ist-offen');
    }));
    const wort = r.querySelector('[data-zl-a-fenster-wort]');
    const dinge = Array.from(r.querySelectorAll('[data-zl-a-ding]'));
    let ruhe = 0; const stand = wort ? wort.innerHTML : '';
    /* Öffner und Gutschein sind Produktfotos mit viel Fläche um das Ding. In der Rechnung (F2) zählt der Abstand zum Ding, nicht zum
       Foto: deshalb wird jedes Foto auf seinen sichtbaren Inhalt zugeschnitten (alles, was sich von der Farbe der Ecke abhebt) und
       so groß, dass es in eine Box der Reihenhöhe passt. Gemessen am Bild aus Shopify, passt also auch zu einem neuen Foto. */
    const zuschneiden = (im, ziel, hoehe) => {
      if (!ziel || !im.naturalWidth || !hoehe) return;
      try {
        const n = 120; // token-ok: Messauflösung, reicht für die Kante
        const c = document.createElement('canvas'); c.width = n; c.height = n;
        const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, n, n);
        const d = x.getImageData(0, 0, n, n).data;
        let x0 = n, y0 = n, x1 = -1, y1 = -1;
        for (let y = 0; y < n; y++) for (let i = 0; i < n; i++) {
          const k = (y * n + i) * 4;
          const anders = d[3] < 10 ? d[k + 3] > 20 : Math.abs(d[k] - d[0]) + Math.abs(d[k + 1] - d[1]) + Math.abs(d[k + 2] - d[2]) > 60; // token-ok: Schwellen gegen die Farbe der Ecke, hoch genug, dass ein weicher Schlagschatten nicht mitzählt
          if (anders) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; }
        }
        if (x1 < 0) return;
        /* So hoch wie die Flaschen, nie höher, und höchstens --zl-a-foto-breit mal so breit wie hoch (Moritz, 07.10.2026) */
        const breit = parseFloat(getComputedStyle(ziel).getPropertyValue('--zl-a-foto-breit')) || 1;
        const cw = x1 - x0 + 1, ch = y1 - y0 + 1, k = Math.min(hoehe / ch, hoehe * breit / cw);
        ziel.style.setProperty('--a-bw', (cw * k).toFixed(1) + 'px');
        ziel.style.setProperty('--a-bh', (ch * k).toFixed(1) + 'px');
        ziel.style.setProperty('--a-iw', (n * k).toFixed(1) + 'px');
        ziel.style.setProperty('--a-ix', (-x0 * k).toFixed(1) + 'px');
        ziel.style.setProperty('--a-iy', (-y0 * k).toFixed(1) + 'px');
        ziel.classList.add('ist-zugeschnitten');
      } catch (e) { /* Bild nicht lesbar: dann bleibt das ganze Foto */ }
    };
    const wennGeladen = (im, f) => { im.loading = 'eager'; if (im.complete && im.naturalWidth) f(); else im.addEventListener('load', f, { once: true }); };
    const zuschnitte = () => {
      /* Handy, Rechnung: Bezug ist die Höhe einer Flasche in der Reihe */
      r.querySelectorAll('.zl-a__fenster .zl-a__ding--foto img').forEach((im) => wennGeladen(im, () => {
        const fl = r.querySelector('.zl-a__fenster .zl-a__ding:not(.zl-a__ding--foto)');
        zuschneiden(im, im.closest('.zl-a__ding'), fl ? fl.getBoundingClientRect().height : 0);
      }));
      /* Desktop, Liste: Bezug ist die Höhe der kleinen Flaschen in der ersten Zeile */
      r.querySelectorAll('.zl-a__karten .zl-a__teil:not(.zl-a__teil--biere) .zl-a__bild img').forEach((im) => wennGeladen(im, () => {
        const fl = r.querySelector('.zl-a__karten .zl-a__bild--flaschen img');
        const bild = im.closest('.zl-a__bild');
        if (!bild || !bild.offsetParent) return;
        zuschneiden(im, bild, fl ? fl.getBoundingClientRect().height : 0);
      }));
    };
    zuschnitte();
    let zuschnittRaf = 0;
    window.addEventListener('resize', () => { cancelAnimationFrame(zuschnittRaf); zuschnittRaf = requestAnimationFrame(zuschnitte); }, { passive: true });
    const zurueck = () => { clearTimeout(ruhe); dinge.forEach((x) => x.classList.remove('ist-dran')); if (wort) wort.innerHTML = stand; };
    dinge.forEach((d) => d.addEventListener('click', () => {
      dinge.forEach((x) => x.classList.remove('ist-dran'));
      d.classList.add('ist-dran');
      if (wort) wort.textContent = d.dataset.zlADing;
      clearTimeout(ruhe); ruhe = setTimeout(zurueck, 2600); // token-ok: so lange steht das Wort
    }));
    /* Tippen daneben: das Ding sinkt sanft zurück auf die Mitte, rechts steht wieder die Summe (Moritz, 07.10.2026) */
    document.addEventListener('pointerdown', (e) => { if (!e.target.closest('[data-zl-a-ding]') && dinge.some((x) => x.classList.contains('ist-dran'))) zurueck(); }, { passive: true });
  };
  const neuLegen = () => { kopfMessen(); wortSetzen(); kurzPruefen(); engPruefen(); kalenderLegen(); leiste(); plusLegen(); folge.legen(); };
  let rafScroll = 0;
  window.addEventListener('scroll', () => { if (!rafScroll) rafScroll = requestAnimationFrame(() => { rafScroll = 0; leiste(); }); }, { passive: true });
  window.addEventListener('resize', neuLegen, { passive: true });
  new ResizeObserver(() => { wortSetzen(); }).observe(root0.querySelector('.zl-o__flaeche'));
  regler();
  kurz();
  formular();
  bilderZaehlen();
  neuLegen();
  einrasten();
  /* Erst messen, wenn beide Schnitte geladen sind (document.fonts.load, nicht fonts.ready), dann Wort und Kauf zeigen.
     Spätestens nach --zl-tl-schrift-warten zeigt sie das CSS ohnehin, gemessen wird dann neu, sobald die Schrift kommt. */
  const zeigen = () => { neuLegen(); root0.removeAttribute('data-zl-o-misst'); };
  const wortEl = root0.querySelector('[data-zl-o-wort]');
  const familie = wortEl ? getComputedStyle(wortEl).fontFamily : '';
  if (document.fonts && document.fonts.load && familie) {
    Promise.all(['400', '700'].map((g) => document.fonts.load(g + ' 16px ' + familie))).then(zeigen, zeigen); // token-ok: Regular und Medium, die Größe zählt beim Laden nicht
  } else zeigen();
})();
